hmi.utils.insert_module({
    name: 'titleDesign',
    instance: null,
    groupType: hmi.constant.groupType.component,
    type: hmi.constant.TITLE_DESIGN,
    pipe: false,
    svgName: 'fixedLabel',
});

hmi.models.titleDesign = function () {
    "use strict";

    //============================================================
    // Public Variables with Default Settings
    //------------------------------------------------------------
    var showMode = hmi.constant.showMode.monitor,
        availableWidth,
        availableHeight,
        valueFormat = d3.format(',.3f');


    //============================================================
    // Private Variables
    //------------------------------------------------------------


    var allData = [],
        type = hmi.constant.TITLE_DESIGN,
        signal = hmi.constant.signals.text,
        groupType = hmi.constant.groupType.component,
        subComponent = {
            main: 0
        },
        selectTargetId,
        isInitialize = false,
        dragBehavior,
        dragTarget,
        dispatch = d3.dispatch('componentChange', 'selectElement', 'selectText'),
        color = {
            normal: '#00a000',
            normalBorder: '#00c000',
            select: '#0000a0',
            warning: '#a0a000',
            warningBorder: '#c0c000',
            alarm: '#a00000',
            alarmBorder: '#c00000'
        },
        defaultWidth = 10,
        defaultHeight = 10;

    var addSubComponents = function (d, data) {
        d.components.push(addMainComponent(d, data));
    };

    var addMainComponent = function (d, data) {
        var result = null;
        if (!data) {
            result = {
                id: d.id + '-sub-' + (subComponent.main + 1),
                key: d.id + '-sub-' + (subComponent.main + 1),
                index: subComponent.main,
                width: defaultWidth,
                height: defaultHeight,
                x: 0,
                y: 0,
                text: d.text,
                font: 'bold 40px sans-serif',
            };
        } else {
            result = {
                id: data.components[subComponent.main].id,
                key: data.components[subComponent.main].key,
                index: data.components[subComponent.main].index,
                width: data.components[subComponent.main].width,
                height: data.components[subComponent.main].height,
                x: data.components[subComponent.main].x,
                y: data.components[subComponent.main].y,
                text: data.text,
                font: data.components[subComponent.main].font,
            };
        }

        return result;
    };

    var selectComponent = function () {
        d3.select(dragTarget)
            .style('stroke', color.select);
    };

    var unSelectComponent = function () {
        d3.select(dragTarget).attr("pointer-events", "all")
            .style('stroke', null);
    };

    var updateComponentPosition = function (d) {
        d.components[subComponent.main].x = d.x;
        d.components[subComponent.main].y = d.y;
        allData[d.index] = d;
    };

    var transformComponentPosition = function (componentTarget, component) {
        component.select = false;
        var parentTargetId = d3.select(componentTarget).attr('parent');

    };

    var transformComponentValue = function (d) {
        d3.select('g#' + d.id).select('.start').text(function () {
            return 0;
        });
    };

    var initializeCanvasObjects = function (gComponent, gEnter) {

        //add main component
        var textAlias = gComponent
            .append('text')
            .classed('component-ele', true)
            .attr('parent', function (d) {
                return d.id;
            })
            .attr('id', function (d) {
                return d.components[subComponent.main].id;
            });

        gEnter.select('text.component-ele')
            .style('font', function (d) {
                return hmi.utils.generateFont(d.config.aliasFont);
            })
            .style('fill', function (d) {
                return d.components[subComponent.main].fill;
            })
            .text(function (d) {
                var text = '';
                if (showMode === hmi.constant.showMode.monitor ||
                    showMode === hmi.constant.showMode.match && d.alias) {
                    text = d.alias;
                } else {
                    text = d.components[subComponent.main].text;
                }
                return text;
            });


        textAlias.on('click', function (event) {
            d3.event.stopPropagation();
            hmi.utils.unSelectComponent();
            event.select = true;
            selectTargetId = d3.select(this).attr('parent');
            switch (showMode) {
                // click in design mode
                case hmi.constant.showMode.design:
                    dragTarget = this;
                    selectComponent();
                    dispatch.selectElement({
                        component: selectTargetId,
                        signal: signal
                    });
                    dispatch.selectText({
                        'key': event.key,
                        'sub_key': selectTargetId,
                        'aliasFont': event.config.aliasFont
                    });
                    break;
                case hmi.constant.showMode.match:

                    dispatch.selectElement({
                        component: selectTargetId,
                        signal: signal
                    });
                    dragTarget = this;
                    selectComponent();
                    break;
            }
        });
    };

    function titleDesign(selection) {
        selection.each(function (data) {
            allData = data;
            var container = d3.select(this).data(data);

            titleDesign.container = this;
            container.selectAll('g.nv-group-titleDesign')
                .data([data])
                .enter().append('g')
                .attr('class', 'nv-group-titleDesign');

            var gEnter = d3.select('g.nv-group-titleDesign')
                .selectAll('g.nv-titleDesign')
                .data(data, function (item) {
                    return item.key;
                });

            var gComponent = gEnter
                .enter()
                .append('g')
                .attr('class', 'nv-titleDesign').attr('id', function (d) {
                    if (d.components[subComponent.main].x === 0) {
                        updateComponentPosition(d);
                    }
                    return d.id;
                })
                .call(hmi.dragBehavior.dragComponent);

            gEnter
                .attr('x', function (d) {
                    return d.x;
                })
                .attr('y', function (d) {
                    return d.y;
                })
                .attr('transform', function (d) {
                    return 'translate(' + d.components[subComponent.main].x + ',' +
                        d.components[subComponent.main].y + ')';
                });

            initializeCanvasObjects(gComponent, gEnter);

            gEnter.exit().remove();
            titleDesign.update = function () {
                container.datum(allData).call(titleDesign);
            };

        });

        return titleDesign;
    }

    titleDesign.dispatch = dispatch;

    titleDesign.options = hmi.utils.optionsFunc.bind(titleDesign);

    titleDesign._calls = new function () {
        this.getObject = function (data) {
            var idNumber = 1;
            var temp = allData[allData.length - 1];
            if (temp) {
                idNumber = parseInt(temp.id.match(/\d+/g)[0]) + 1;
            }
            var result = null;
            if (!data) {
                result = {
                    id: 'fixed-label-' + (idNumber),
                    key: 'fixed-label-' + (idNumber),
                    index: allData.length,
                    groupType: groupType,
                    type: type,
                    width: defaultWidth,
                    height: defaultHeight,
                    x: 0,
                    y: 0,
                    text: 'fixed-label-' + (allData.length + 1),
                    config: {
                        aliasFont: {
                            weight: 'bold',
                            size: '15px',
                            family: 'sans-serif'
                        },
                        valueFont: {
                            weight: 'bold',
                            size: '15px',
                            family: 'sans-serif',
                            valueFormat: '+,.3f'
                        }
                    },
                    components: [],
                    data: {
                        value: 0
                    }
                };
                addSubComponents(result, null);
            } else {
                result = {
                    id: data.id,
                    key: data.key,
                    index: data.index,
                    groupType: groupType,
                    type: data.type,
                    width: data.width,
                    height: data.height,
                    x: data.x,
                    y: data.y,
                    text: data.text,
                    config: data.config,
                    components: [],
                    data: {
                        value: 0
                    }
                };
                addSubComponents(result, data);
            }

            return result;
        };
        this.updateConfig = function (data) {
            var item = allData.find(function (item) {
                return item.key === data.key;
            });
            if (item) {
                item.alias = data.alias;
                item.config.aliasFont = data.config.aliasFont ? data.config.aliasFont : item.config.aliasFont;
                item.config.valueFont = data.config.valueFont ? data.config.valueFont : item.config.valueFont;
            }
            return item;
        };
        this.unSelectComponent = unSelectComponent;
        this.updateComponentPosition = updateComponentPosition;
        this.transformComponentPosition = transformComponentPosition;
    };

    titleDesign._options = Object.create({}, {
        // simple options, just get/set the necessary values
        showMode: {
            get: function () {
                return showMode;
            },
            set: function (_) {
                showMode = _;
            }
        },
        availableWidth: {
            get: function () {
                return availableWidth;
            },
            set: function (_) {
                availableWidth = _;
            }
        },
        availableHeight: {
            get: function () {
                return availableHeight;
            },
            set: function (_) {
                availableHeight = _;
            }
        },
        valueFormat: {
            get: function () {
                return valueFormat;
            },
            set: function (_) {
                valueFormat = _;
            }
        }
    });

    hmi.utils.initOptions(titleDesign);

    return titleDesign;
};